import { render, staticRenderFns } from "./privacy.vue?vue&type=template&id=35fb9221&scoped=true&"
import script from "./privacy.vue?vue&type=script&lang=js&"
export * from "./privacy.vue?vue&type=script&lang=js&"
import style0 from "./privacy.vue?vue&type=style&index=0&lang=css&"
import style1 from "./privacy.vue?vue&type=style&index=1&id=35fb9221&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fb9221",
  null
  
)

export default component.exports